import { useCallback, useEffect, useState } from 'react'

export default function useRoveFocus<T>({
  element,
  items,
  onClick = () => {},
}: {
  element
  items: T[]
  onClick?: (item: T, index?: number) => void
}) {
  const [currentFocus, setCurrentFocus] = useState<number | null>(null)
  const size = items.length

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'ArrowDown') {
        // Down arrow
        e.preventDefault()
        if (currentFocus === null) {
          setCurrentFocus(0)
        } else {
          setCurrentFocus(currentFocus === size - 1 ? 0 : currentFocus + 1)
        }
      } else if (e.key === 'ArrowUp') {
        // Up arrow
        e.preventDefault()
        if (currentFocus === null) {
          setCurrentFocus(size - 1)
        } else {
          setCurrentFocus(currentFocus === 0 ? size - 1 : currentFocus - 1)
        }
      } else if (e.key === 'Enter' && onClick) {
        // Enter
        e.preventDefault()
        if (currentFocus !== null) {
          onClick(items[currentFocus], currentFocus)
        }
      }
    },
    [size, currentFocus, setCurrentFocus, items, onClick]
  )

  useEffect(() => {
    if (element) {
      element.addEventListener('keydown', handleKeyDown, false)
      return () => {
        element.removeEventListener('keydown', handleKeyDown, false)
      }
    }
  }, [handleKeyDown, element])

  return [currentFocus, setCurrentFocus]
}
